import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { DealTodo } from "~/models/DealTodo";
import { generatePath } from "~/utils/generatePath";

const paths = {
	index: "/deals/:deal_id/deal_todos"
} as const;

const buildIndexPath = (dealId: number): string =>
	generatePath(paths.index, { deal_id: dealId });

export const dealTodosCacheKey = (dealId: number): string =>
	buildIndexPath(dealId);

export const useDealTodos = (dealId: number): SwrReturnType<DealTodo[]> => {
	const { data, mutate, error, isLoading } = useSWR<DealTodo[]>(
		dealTodosCacheKey(dealId)
	);

	return {
		data: data ?? null,
		error,
		isLoading,
		mutate
	};
};
